module.exports = __webpack_public_path__ + "static/media/jeff_lu.7f854da1.png";